import type { AdvancedSearchInput } from '@ingenico/react-ui/advanced-search';
import type { AdvancedSchedulingValues } from '../../../components/advanced-scheduling-section/AdvancedSchedulingSection.types';
import type { DMSearchRequest } from '../common.model';
import type { EnumDeploymentRequestStatus } from './enums.model';

export enum ScheduleActivitySeverity {
  AsSoonAsPossible = 'ASAP',
  SelectDate = 'SCHEDULED',
}

export interface ExclusionDate {
  readonly date?: Date;
}

export interface TimeSlot {
  readonly start: Date;
  readonly end?: Date;
}

export interface ScheduleOption {
  readonly date?: Date;
  readonly exclusionDates?: ExclusionDate[];
  readonly timeSlot?: TimeSlot;
  readonly severity: 'SCHEDULED' | 'ASAP';
}

export interface AppDeletionBody {
  readonly applicationName: string;
  readonly applicationId: string;
  readonly applicationLogo?: string;
  readonly applicationVersionIds: string[];
}

export interface SystemPackageDeletionBody {
  readonly systemPackageName: string;
  readonly systemPackageId: string;
  readonly systemPackageLogo?: string;
  readonly systemPackagesVersionIds: string[];
}

export interface DeploymentRequestBody {
  readonly name?: string;
  readonly description?: string;
  readonly isCheckedAdvancedFilters?: boolean;
  readonly groupId?: string;
  readonly deviceCount?: number;
  readonly configurationId?: string;
  readonly advancedFiltersCriteria?: AdvancedSearchInput[];
  readonly applications?: AppDeletionBody[];
  readonly systemPackages?: SystemPackageDeletionBody[];
  readonly scheduleOption?: ScheduleOption;
  readonly advancedScheduling?: AdvancedSchedulingValues;
}

export interface SimpleDeploymentRequestResponse {
  readonly status: EnumDeploymentRequestStatus;
  readonly name: string;
  readonly id: string;
}

export interface DeploymentDevicesDynamicGroupQuery {
  readonly base: DMSearchRequest;
  readonly filters: AdvancedSearchInput[];
}
